export enum WsEvent {
  chatMessage = 'chat_message',
  aiDemoMessage = 'ai_demo_message',
  countersUpdate = 'counters_update',
  managerNotification = 'manager_notification',
  userListFill = 'user_list_fill'
}

export type WsEventBase<K extends WsEvent, D extends Record<string, any>> = {
  kind: K;
  data: D;
};
